<!--Toolbar for auth modules-->
<div class="card">
    <p-toolbar>
        <div class="p-toolbar-group-start">
            <i *ngIf="isMobileScreen" class="p-toolbar-separator pi pi-bars mr-3"
                style="vertical-align: middle; cursor: pointer" (click)="toggle()"></i>
            <h1 class="my-0" style="color: #F86F03;">RMS</h1>
            <!-- <a href="#" class="cursor-pointer">JOB CONNECT
                <img src="../../../../assets/jc_logo_light.png" alt="samsiddhi logo" width="150px" loading="lazy">
            </a> -->
        </div>
        <div class="p-toolbar-group-end">
            <div class="flex justify-content-between align-items-center">
                <!-- <p-button label="About" [text]="true"></p-button>
                <p-button label="Contact" [text]="true"></p-button>
                <p-button label="Blogs" [text]="true"></p-button>
                <p-button label="Forums" [text]="true"></p-button> -->
                <!-- <p-divider layout="vertical"></p-divider> -->
                <p-button label="{{ isSignInRoute() ? 'Join now' : 'Sign In' }}" [rounded]="true"
                    [routerLink]="[isSignInRoute() ? '/auth/sign-up' : '/auth/sign-in']"></p-button>
            </div>
        </div>
    </p-toolbar>
</div>

<!--sidenav-->
<p-sidebar [(visible)]="isSidebarVisible">
    <ng-template pTemplate="header">
        <h1 class="text-primary my-0">RMS</h1>
        <!-- <img src="../../../../assets/jc_logo_light.png" alt="samsiddhi logo" width="150px" loading="lazy"> -->
    </ng-template>
    <ng-template pTemplate=" content">

    </ng-template>
    <ng-template pTemplate="footer">

    </ng-template>
</p-sidebar>